import { select, Selection } from 'd3-selection'

import TooltipService from 'live/services/charts/tooltip'
import dateService from 'live/services/date'
import { defaultOptions } from 'highcharts'
import { format } from 'd3-format'
import colors from 'live/services/colors'
import { css } from 'emotion'
export const getColor = (index: number): string => colors.color(`${index}`)
export const secondsFormat = format('02d')

const tooltipCss = css`
    position: absolute;
    font-size: 12px;
    font-family: 'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif;
    height: auto !important;
    border: 1px solid;
    border-color: var(--gray-400);
    padding: 5px;
    color: #333;
    white-space: nowrap;
    opacity: 1;
    visibility: hidden;

    .tooltip-contents .tooltip-data-value abbr {
        color: #333;
    }

    .tooltip-contents .tooltip-date-time,
    .tooltip-contents .tooltip-data-value,
    .tooltip-event-icon .tooltip-date-time {
        font-family: SourceSansPro-SemiBold;
        font-size: 13px;
        margin-bottom: 1px;
    }

    .tooltip-icon {
        font-size: 21px;
    }
`

export default class Tooltip {
    private el: Selection<HTMLElement, null, HTMLElement, null>
    private tooltip: Selection<HTMLDivElement, null, HTMLElement, null>

    constructor(el: Selection<HTMLElement, null, HTMLElement, null>) {
        const options = TooltipService.createTooltip('group', false, 'line', false, [])
        this.el = el

        this.tooltip = this.el
            .append('div')
            .classed(tooltipCss, true)
            .style(
                'background-color',
                options.backgroundColor ?? (defaultOptions.tooltip?.backgroundColor || '#f7f7f7')
            )
            .style('border-radius', options.borderRadius ?? (defaultOptions.tooltip?.borderRadius || 0))
            // .style('border-color', options.borderColor ?? (defaultOptions.tooltip?.borderColor || '#C8CCD4'))

        this.tooltip.append('div').classed('tooltip-contents', true)
    }

    render(
        x: number,
        y: number,
        value: number,
        color: string,
        timestamp: number,
        nextTimestamp: number,
        isVertical: boolean,
        width: number,
        yTop: number
    ): void {
        const data = [
            { name: 'State', value },
            { name: 'From', value: dateService.formatDateTime(timestamp) }
        ]
        if (nextTimestamp) {
            data.push({ name: 'To', value: dateService.formatDateTime(nextTimestamp) })
            data.push({ name: 'Duration', value: dateService.getMoment(nextTimestamp).from(timestamp, true) })
        }

        const margin = 15
        const { width: tooltipWidth, height: tooltipHeight } = this.tooltip.node().getBoundingClientRect()
        let tx = x + margin
        let ty = y + margin
        if (!isVertical) {
            if (tx > width - tooltipWidth) {
                tx = x - margin - tooltipWidth
            }
        } else {
            ty = y - margin - tooltipHeight
            if (ty < yTop) {
                ty = y + margin
            }
        }

        this.tooltip
            .style('display', 'block')
            .style('visibility', 'visible')
            .style('left', tx + 'px')
            .style('top', ty + 'px')
            .select('div.tooltip-contents')
            .selectAll('div')
            .data(data)
            .join('div')
            .html(d =>
                d.name === 'State'
                    ? `<span class="tooltip-icon" style="color: ${color};">&#9724;</span> <span class="tooltip-date-time">${d.value}</span>`
                    : `<span class="tooltip-data-title">${d.name}</span>: <span class="tooltip-data-value">${d.value}</span>`
            )
    }

    hide(): void {
        this.tooltip.style('visibility', 'hidden')
    }

    destroy(): void {
        this.el.remove()
    }
}
